module.exports = __webpack_public_path__ + "img/faro_energy.a5f460e2.svg";